export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const RESET = 'RESET';
